// @flow
import * as React from 'react'
import { FormattedMessage } from 'translations';
import { isMobileBrowser } from 'app/utils/browser';
import VEHICLE_CLASS from 'mz-sdk/constants/vehicleClass';
import Button from 'mz-ui-kit/core/Button';
import CheckboxField from 'mz-ui-kit/form/CheckboxField';
import FilterMeetAndGreet from './FilterMeetAndGreet';
import RideTracking from './RideTracking'
import FilterSuitcases from './FilterSuitcases';
import FilterSupplierScore from './FilterSupplierScore';
import FilterVehicleClass from './FilterVehicleClass'

import { FiltersContainer, FilterOption, ButtonWrapper, BlackLabel, FilterTopSpacer } from './elements';


const messages = {
  apply: { id: 'SEARCH_RESULTS.APPLY'},
  reset: { id: 'SEARCH_RESULTS.RESET'}
};

function filtersReducer(state, action) {
  switch (action.type) {
    case 'SET_FILTER':
      return { ...state, [action.payload.filterKey]: action.payload.filterValue }

    case 'RESET_FILTERS':
      return { ...action.payload }

    default:
      return state
  }
}

export function FiltersForm({ onApplyChanges, initFilters, emptyFilters }) {
  const [state, dispatch] = React.useReducer(filtersReducer, initFilters)

  const handleClickApply = () => {
    onApplyChanges?.(state);
  }

  const handleFilterChange = key => value => {
    dispatch({ type: 'SET_FILTER', payload: { filterKey: key, filterValue: value } })
  }

  const handleClickReset = () => {
    dispatch({ type: 'RESET_FILTERS', payload: emptyFilters })
    onApplyChanges?.(emptyFilters);
  }

  return (
    <FiltersContainer>
      {/* Cases when device is desktop and the height is smaller than 722px, popover component will sit underneath the appbar and the first filter option will not be visible*/}
      {!isMobileBrowser && <FilterTopSpacer />}
      <FilterOption>
        <FilterSuitcases
          onChange={handleFilterChange('suitcaseCount')}
          value={state.suitcaseCount}
        />
      </FilterOption>

      <FilterOption>
        <FilterSupplierScore
          onChange={handleFilterChange('supplierScore')}
          value={state.supplierScore}
        />
      </FilterOption>

      <FilterOption>
        <FilterMeetAndGreet
          onChange={handleFilterChange('meetAndGreet')}
          value={state.meetAndGreet}
        />
      </FilterOption>

      <FilterOption>
        <RideTracking
          onChange={handleFilterChange('rideTracking')}
          value={state.rideTracking}
        />
      </FilterOption>

      <FilterOption>
        <CheckboxField
          input={{ onChange: handleFilterChange('green'), value: state.green }}
          label={(
            <BlackLabel>
              <FormattedMessage id="SEARCH_RESULTS.SHOW_ONLY_GREEN" />
            </BlackLabel>
          )}
        />
      </FilterOption>

      {[
          VEHICLE_CLASS.FIRST,
          VEHICLE_CLASS.BUSINESS,
          VEHICLE_CLASS.ECONOMY,
          VEHICLE_CLASS.STANDARD,
      ].map(vehicleClass => (
        <FilterOption key={vehicleClass}>
          <FilterVehicleClass
            vehicleClass={vehicleClass}
            value={state.vehicleClass === vehicleClass}
            onChange={() => handleFilterChange('vehicleClass')(
              state.vehicleClass === vehicleClass ? null : vehicleClass
            )}
          />
        </FilterOption>
      ))}

      <br/>
      <ButtonWrapper>
        <Button
          color="secondary"
          appearance="flat"
          onClick={handleClickReset}
        >
          <FormattedMessage {...messages.reset} />
        </Button>
        <Button
          color="secondary"
          onClick={handleClickApply}
          fullWidth
        >
          <FormattedMessage {...messages.apply} />
        </Button>
      </ButtonWrapper>
    </FiltersContainer>
  )
}

export default FiltersForm
